<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="封面" prop="cover">
                <a-select v-model="queryParam.type" placeholder="请选择勋章">
                  <a-select-option :key="0">挑战5公里勋章</a-select-option>
                  <a-select-option :key="1">挑战10公里勋章</a-select-option>
                  <a-select-option :key="2">达标7天勋章</a-select-option>
                  <a-select-option :key="3">达标30天勋章</a-select-option>
                  <a-select-option :key="4">达标100天勋章</a-select-option>
                  <a-select-option :key="5">达标365天勋章</a-select-option>
                  <a-select-option :key="6">累计30万步勋章</a-select-option>
                  <a-select-option :key="7">累计100万步勋章</a-select-option>
                  <a-select-option :key="8">累计300万步勋章</a-select-option>
                  <a-select-option :key="9">累计1000万步勋章</a-select-option>
                  <a-select-option :key="10">连续佩戴1个月</a-select-option>
                  <a-select-option :key="11">连续佩戴1年</a-select-option>
                  <a-select-option :key="12">骑行10公里</a-select-option>
                  <a-select-option :key="13">骑行50公里</a-select-option>
                  <a-select-option :key="14">骑行百公里</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="达标值" prop="targetData">-->
<!--                  <a-input v-model="queryParam.targetData" placeholder="请输入达标值" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否启用 0-未启用 1-启用" prop="isOpen">-->
<!--                  <a-input v-model="queryParam.isOpen" placeholder="请输入是否启用 0-未启用 1-启用" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['joe:medal:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['joe:medal:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['joe:medal:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['joe:medal:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <img style="width: 48px;height: 48px;" v-image-preview :src="record.cover" slot="cover" slot-scope="text, record">


        <span slot="isOpen" slot-scope="text, record">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.isOpen == 1" @change="changeIsOpen($event,record)"/>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['joe:medal:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['joe:medal:edit']">
            <a-icon type="edit" />修改
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['joe:medal:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['joe:medal:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMedal,listMedal, delMedal,changeIsOpen } from '@/api/joe/medal'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Medal',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: null,
        cover: null,
        targetData: null,
        isOpen: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '勋章类型',
          dataIndex: 'type',
          ellipsis: true,
          customRender: function (t) {
            if(t == 0) {
              return '挑战5公里勋章'
            } else if(t == 1) {
              return '挑战10公里勋章'
            } else if(t == 2) {
              return '达标7天勋章'
            }  else if(t == 3) {
              return '达标30天勋章'
            }  else if(t == 4) {
              return '达标100天勋章'
            }  else if(t == 5) {
              return '达标365天勋章'
            }  else if(t == 6) {
              return '累计30万步勋章'
            }  else if(t == 7) {
              return '累计100万步勋章'
            }  else if(t == 8) {
              return '累计300万步勋章'
            }  else if(t == 9) {
              return '累计1000万步勋章'
            } else if(t == 10) {
              return '连续佩戴1个月'
            }  else if(t == 11) {
              return '连续佩戴1年'
            }  else if(t == 12) {
              return '骑行10公里'
            }  else if(t == 13) {
              return '骑行50公里'
            }  else {
              return '骑行百公里'
            }
          },
          align: 'center'
        },
        {
          title: '封面',
          dataIndex: 'cover',
          ellipsis: true,
          scopedSlots: { customRender: 'cover' },
          align: 'center'
        },
        // {
        //   title: '达标值',
        //   dataIndex: 'targetData',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '是否启用',
          dataIndex: 'isOpen',
          ellipsis: true,
          scopedSlots: { customRender: 'isOpen' },
          align: 'center'
        },
        // {
        //   title: '插入时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询勋章列表 */
    getList () {
      this.loading = true
     pageMedal(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        cover: undefined,
        targetData: undefined,
        isOpen: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    changeIsOpen (e,record) {
      record.isOpen = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          '操作成功'
        )
        return  record.isOpen = e ? 1 : 0
      })
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delMedal(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('joe/medal/export', {
            ...that.queryParam
          }, `勋章_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
